module.exports = __webpack_public_path__ + "assets/img/upRechargeBtn.b75058c8.png";